import { EmployeeProductivityCreate } from "components/hr-metrics/employee-productivity/create/EmployeeProductivityCreate";
import { ImportDataContainer } from "containers/hr-metrics/employee-productivity/create/ImportDataContainer";
import SelectPeriodContainer from "containers/hr-metrics/employee-productivity/create/SelectPeriodContainer";
import { useLocation } from "react-router-dom";
import { getPathUrl } from "utils/utils";

const EmployeeProductivityCreateContainer = () => {
    const location = useLocation()
    const lastPath = getPathUrl(location, '/', -1).toString()

    const content = (path) => {
        switch (path) {
            case 'select-period':
                return {
                    path: 'select-period',
                    item: <SelectPeriodContainer/>,
                    sequence: 1
                }
            case 'import-data':
                return {
                    path: 'import-data',
                    item: <ImportDataContainer/>,
                    sequence: 2
                }
            default:
                return {
                    path: 'select-period',
                    item: <SelectPeriodContainer/>,
                    sequence: 1
                }
        }
    } 
    

    return (
        <EmployeeProductivityCreate content={content} lastPath={lastPath}/>
    )
}

export default EmployeeProductivityCreateContainer
